import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import updateSwiperControlsVisibility from './swiper-controls.js';

export default {
	init() {
		const selector = '.layout.listing.listing-people .cards-swiper';
		const sliders = document.querySelectorAll(selector);
		if (!sliders.length) return;

		function setEqualSlideHeights(sliderEl) {
			const slides = sliderEl.querySelectorAll('.swiper-slide');
			if (!slides.length) return;

			slides.forEach((slide) => {
				slide.style.height = '';
			});

			let maxHeight = 0;
			slides.forEach((slide) => {
				maxHeight = Math.max(maxHeight, slide.getBoundingClientRect().height);
			});

			if (!maxHeight) return;
			slides.forEach((slide) => {
				slide.style.height = `${Math.ceil(maxHeight)}px`;
			});
		}

		function scheduleEqualize(sliderEl) {
			requestAnimationFrame(() => setEqualSlideHeights(sliderEl));
		}

		function initOne(sliderEl) {
			const sectionEl = sliderEl.closest('.cards-section') || sliderEl.parentElement;
			const paginationEl = sectionEl ? sectionEl.querySelector('.swiper-pagination') : null;
			const nextEl = sectionEl ? sectionEl.querySelector('.swiper-button-next') : null;
			const prevEl = sectionEl ? sectionEl.querySelector('.swiper-button-prev') : null;

			const pagination = paginationEl ? { el: paginationEl, clickable: true } : undefined;
			const navigation = nextEl && prevEl ? { nextEl, prevEl } : undefined;

			if (sliderEl._listingPeopleSwiper) {
				try {
					sliderEl._listingPeopleSwiper.destroy(true, true);
				} catch (e) {
					// no-op
				}
				sliderEl._listingPeopleSwiper = undefined;
			}

			const swiper = new Swiper(sliderEl, {
				modules: [Navigation, Pagination],
				slidesPerView: 3,
				spaceBetween: 33,
				grabCursor: true,
				watchOverflow: true,
				observer: true,
				observeParents: true,
				pagination,
				navigation,
				breakpoints: {
					0: { slidesPerView: 1 },
					769: { slidesPerView: 2 },
					1025: { slidesPerView: 3 },
				},
			});

			sliderEl._listingPeopleSwiper = swiper;

			const updateControls = () =>
				updateSwiperControlsVisibility(swiper, {
					sliderEl,
					sectionEl,
					paginationEl,
					nextEl,
					prevEl,
				});

			updateControls();

			scheduleEqualize(sliderEl);
			swiper.on('resize', () => {
				scheduleEqualize(sliderEl);
				updateControls();
			});
			swiper.on('breakpoint', () => {
				scheduleEqualize(sliderEl);
				updateControls();
			});
			swiper.on('slideChangeTransitionEnd', () => scheduleEqualize(sliderEl));
			swiper.on('imagesReady', () => scheduleEqualize(sliderEl));

			const imgs = sliderEl.querySelectorAll('img');
			imgs.forEach((img) => {
				if (img.complete) return;
				img.addEventListener('load', () => scheduleEqualize(sliderEl), { once: true });
			});

			if (window.ResizeObserver) {
				const ro = new ResizeObserver(() => scheduleEqualize(sliderEl));
				ro.observe(sliderEl);
			}
		}

		sliders.forEach((sliderEl) => initOne(sliderEl));

		if (window.jQuery) {
			window.jQuery(document).on('facetwp-loaded', () => {
				document.querySelectorAll(selector).forEach((sliderEl) => initOne(sliderEl));
			});
		}
	},
};
